enum InviteRequestStatusConstants {
  UNDEFINED = 'UNDEFINED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  ONBOARDING_COMPLETED = 'ONBOARDING_COMPLETED',
}

export default InviteRequestStatusConstants;
